import { Alert, Box, Card, CardContent, Grid, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import VistaIzquierda from './vista/VistaIzquierda';
import TabPanel from './vista/TabPanel';
import ActividadesTab from './vista/ActividadesTab';
import SociosTab from './vista/SociosTab';
import AntecedentesTab from './vista/AntecedentesTab';
import toast from 'react-hot-toast';
import ProductosTab from './vista/ProductosTab';
import ContactoTab from './vista/ContactoTab';
import SolicitarEdicion from './vista/SolicitarEdicion';
import { imgToUrl } from '../lib/imgToUrl';
import ObjetivosTab from './vista/ObjetivosTab';


const VistaEmpresa = () => {
    const { nombre_empresa } = useParams();
    const [datosEmpresa, setDatosEmpresa] = useState(null);
    const [actividades, setActividades] = useState({});
    const [socios, setSocios] = useState({});
    const [antecedentes, setAntecedentes] = useState({});
    const [productosServicios, setProductosServicios] = useState({});
    const [contactoComercial, setContactoComercial] = useState({});
    const [objetivos, setObjetivos] = useState({});
    const [imagenes, setImagenes] = useState({});
    const [loaded, setLoaded] = useState(false);

    const [nuevasImagenes, setNuevasImagenes] = useState({});
    const [figuraJuridica, setFiguraJuridica] = useState(null);
    const [catalogoFiguras, setCatalogoFiguras] = useState([]);
    const [imagenesDatos, setImagenesDatos] = useState([]);
    const getDatos = async () => {
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/empresa?nombre=${nombre_empresa}`)
            .then(res => res.json())
            .then(async (respuesta) => {
                if (respuesta.status === 'success') {
                    //console.log(respuesta);
                    // obtener figura juridica
                    if (respuesta.data.figura_juridica) {
                        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/figuras_juridicas_es`)
                            .then(res => res.json())
                            .then((res) => {
                                setCatalogoFiguras(res.data);
                                let fig = res.data.find((figura) => figura.id == respuesta.data.figura_juridica);
                                respuesta.data.figura_juridica = fig.nombre;
                            });

                    } else {
                        respuesta.data.figura_juridica = respuesta.data.figura_juridica_otro;
                    }
                    setDatosEmpresa(respuesta.data);
                    setActividades(respuesta.data.actividades_economicas);
                    setSocios(respuesta.data.socios);
                    setAntecedentes(respuesta.data.antecedentes);
                    setProductosServicios(respuesta.data.productos_servicios);
                    setContactoComercial(respuesta.data.contacto_comercial);
                    setObjetivos(respuesta.data.objetivos);
                    setImagenes(respuesta.data.imagenes);
                    setImagenesDatos(respuesta.data.imagenes_nuevas);
                    setLoaded(true);
                    //console.log(respuesta.data);

                } else {
                    toast.error("Empresa no encontrada");
                }
            })
            .catch((err) => console.log(err));
    }
    //// Cuando alguno de los estados cambie, deberia actualizarse datosEmpresa: 
    useEffect(() => {
        setDatosEmpresa((prevDatos) => ({
            ...prevDatos,
            actividades_economicas: actividades,
            socios,
            antecedentes,
            productos_servicios: productosServicios,
            contacto_comercial: contactoComercial,
            imagenes,
        }));
    }, [actividades, socios, antecedentes, productosServicios, contactoComercial, imagenes]);



    const setData = (e, seccion = null, index = null) => {
        let newVal = e.target.value;
        let name = e.target.name;
        switch (tab) {
            case 3: // actividades economicas
                //console.log(newAct);
                if (name != 'imagenes') {
                    setActividades((prev) => {
                        let newAct = { ...prev };
                        if (!isNaN(index) && index !== null) {
                            newAct[seccion][index][name] = newVal;
                        } else { // caso de productos / giros
                            newAct[seccion] = newVal;
                        }
                        return newAct;
                    }
                    );
                }
                else {
                    setDatosEmpresa((prev) => ({ ...prev, imagenes_nuevas: newVal }));
                    setImagenesDatos(newVal);
                }
                break;
            case 0: // Socios
                if (name != 'imagenes') {
                    setSocios((prev) => {
                        let newSoc = { ...prev };
                        newSoc[name] = newVal;
                        return newSoc;
                    });
                } else {
                    setDatosEmpresa((prev) => ({ ...prev, imagenes_nuevas: newVal }));
                    setImagenesDatos(newVal);
                }
                break;
            case 1: // antecedente
                if (name != 'imagenes') {
                    setAntecedentes((prev) => {
                        let newAnt = { ...prev };
                        newAnt[name] = newVal;
                        return newAnt;
                    });
                }
                else {
                    setDatosEmpresa((prev) => ({ ...prev, imagenes_nuevas: newVal }));
                    setImagenesDatos(newVal);
                }
                break;
            case 4: //prods. y servs.
                if (!['imagenes', 'galeria_actividades_procesos', 'galeria_productos_servicios'].includes(name)) {
                    setProductosServicios((prev) => {
                        let newProd = { ...prev };
                        if (index != null) {
                            newProd[seccion][index][name] = newVal;
                        } else {
                            newProd[name] = newVal;
                        }
                        return newProd;
                    });
                }
                else {
                    setDatosEmpresa((prev) => ({ ...prev, imagenes_nuevas: newVal }));
                    setImagenesDatos(newVal);
                }
                break;
            case 5: // contacto comercial
                setContactoComercial((prev) => {
                    let newProd = { ...prev };
                    if (index != null) {
                        newProd[seccion][index][name] = newVal;
                    } else {
                        newProd[name] = newVal;
                    }
                    return newProd;
                });
                break;
            case 2: // objetivos
                setObjetivos((prev) => {
                    let newObj = { ...prev };
                    newObj[name] = newVal;
                    return newObj;
                });
                break;
            default:
                break;
        }
    }

    const setDataIzq = (e) => {
        let newVal = e.target.value;
        let name = e.target.name;
        setDatosEmpresa((prev) => {
            let newD = { ...prev, [name]: newVal };
            return newD;
        });
    }

    const objectToFormData = (obj, formData, parentKey = '') => {
        formData = formData || new FormData();

        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                const fullKey = parentKey ? `${parentKey}[${key}]` : key;

                if (value instanceof File) {
                    // Si el valor es un objeto File, agrégalo directamente al FormData
                    formData.append(fullKey, value);
                } else if (typeof value === 'object' && value !== null) {
                    // Si el valor es un objeto, llama recursivamente a la función para manejar la anidación
                    objectToFormData(value, formData, fullKey);
                } else {
                    // Si es un valor simple, agrégalo al FormData
                    formData.append(fullKey, value);
                }
            }
        }

        return formData;
    }

    const reduceImg = (datos) => {
        const resultado = datos.reduce((acumulador, elemento) => {
            // Verifica si ya existe un subarreglo para el índice actual
            const grupo = acumulador[elemento.indice];

            // Si no existe, lo crea y añade el primer elemento
            if (!grupo) {
                acumulador[elemento.indice] = [elemento];
            } else {
                // Si ya existe, añade el elemento actual al subarreglo correspondiente
                grupo.push(elemento);
            }

            return acumulador;
        }, []);

        // Elimina cualquier espacio vacío en el arreglo final
        const arregloFinal = resultado.filter(Boolean);
        return arregloFinal;
    }

    const handleUpdate = async (seccion) => {
        window.scrollTo(0, 0);
        let bodyContent = {};
        let err, err1, err2;
        // asignar los datos dependiendo de la seccion
        switch (seccion) {
            case 'datos_generales':
                bodyContent = datosEmpresa;
                bodyContent.logotipo = datosEmpresa.imagenes_nuevas.find((i) => i.seccion == 'logotipo');
                bodyContent.galeria = datosEmpresa.imagenes_nuevas.filter((i) => i.seccion == 'galeria');
                break;
            case 'actividades_economicas':
                // validar que no haya campos vacios en ningun campo nuevo
                err1 = actividades.productos.map((producto) => {
                    return Object.values(producto).includes('');
                });

                err2 = actividades.unidades_produccion.map((unidad) => {
                    return Object.values(unidad).includes('')
                });
                err = [...err1, ...err2];

                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                let imagenes = {
                    productos_servicios: reduceImg(imagenesDatos.filter((img) => img.paso == 'actividades_economicas' && img.seccion == 'galeria_productos_servicios')),
                    unidades_produccion: reduceImg(imagenesDatos.filter((img) => img.paso == 'actividades_economicas' && img.seccion == 'galeria_unidades_produccion')),
                    galeria_actividades: imagenesDatos.filter((img) => img.seccion == 'galeria_actividades')
                };
                bodyContent = { ...actividades, id: datosEmpresa.id, imagenes };
                break;
            case 'socios':
                err = Object.values(socios).map((dato) => {
                    return isNaN(dato);
                });
                if (err.includes(true)) {
                    return toast.error("Valida los campos");
                }
                bodyContent = { ...socios, id: datosEmpresa.id, imagenes: imagenesDatos };
                break;
            case 'antecedentes':
                err = Object.values(antecedentes).map((dato) => {
                    return dato == '';
                });
                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                bodyContent = { ...antecedentes, id: datosEmpresa.id, imagenes: imagenesDatos };
                break;
            case 'productos_servicios':
                err = Object.values(productosServicios).map((dato) => {
                    return dato == '';
                });
                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                let imgs = {
                    actividades_procesos: reduceImg(imagenesDatos.filter((i) => i.paso == 'productos_servicios' && i.seccion == 'galeria_actividades_procesos')),
                    productos_servicios: reduceImg(imagenesDatos.filter((i) => i.paso == 'productos_servicios' && i.seccion == 'galeria_productos_servicios'))
                }
                bodyContent = { ...productosServicios, id: datosEmpresa.id, imagenes: imgs };
                break;
            case 'contacto_comercial':
                err = Object.keys(contactoComercial).map((key) => {
                    let val = contactoComercial[key];
                    if (['numero_int', 'whatsapp'].includes(key)) {
                        return false;
                    } else {
                        return val == '';
                    }
                });
                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                bodyContent = { ...contactoComercial, id: datosEmpresa.id };
                break;
            case 'objetivos':
                err = Object.keys(objetivos).map((key) => {
                    let val = objetivos[key];
                    if ('proposito' != key) {
                        if (val.length > 0) return false
                        return true;
                    } else {
                        return false
                    }
                });
                if (err.includes(true)) {
                    return toast.error("No puede haber campos vacíos");
                }
                bodyContent = { ...objetivos, id: datosEmpresa.id };
                break;
        }
        bodyContent.seccion = seccion;
        // primero actualizar imagenes, despues actualizar datos
        const formData = objectToFormData(bodyContent);

        // actualizar datos
        // let url = 'http://perfiltest.test/';
        let url = 'https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/actualizar_empresa';
        await fetch(url, {
            method: "POST",
            body: formData
        })
            .then(res => res.json())
            .then((respuesta) => {
                console.log(respuesta);
                toast[respuesta.status](respuesta.message);
            });
    }

    useEffect(() => {
        const init = async () => await getDatos();
        init();
    }, []);


    const [tab, setTab] = useState(0);
    const handleTab = (e, v) => {
        setTab(v);
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const [editable, setEditable] = useState(false);
    const handleEditStatus = () => {
        // manejar un estado para utilizar edicion en cada tab
        editable ? setEditable(false) : setEditable(true);
    }

    useEffect(() => {
        if (editable) {
            window.scrollTo(0, 0);
        }
    }, [editable]);

    const setImgs = async (tab, data, seccion) => {
        switch (tab) {
            case 'datos_generales':
                // en esta seccion solo hay logotipo y galeria (img y [imgs])
                let newData = { ...datosEmpresa, imagenes_nuevas: data };
                setDatosEmpresa(newData);
                //console.log(data);
                break;
            case 'actividades_economicas':
                // productos / servicios

                // unidades de produccion

                // fotogaleria

                break;
            case 'socios':

                break;
            case 'antecedentes':
                break;
            case 'productos_servicios':
                break;
            case 'contacto_comercial':
                break;
        }
    };

    useEffect(() => { console.log(nuevasImagenes) }, [nuevasImagenes]);

    if (loaded) {
        return (
            <Box sx={{ m: { lg: 4, xs: 0 } }}>
                <Grid container spacing={3}>
                    {datosEmpresa.status != 1 &&
                        <Grid item xs={12}>
                            <Alert severity="error">Este perfil empresarial es preliminar, los datos mostrados no estarán completos y/o no serán completamente correctos.</Alert>
                        </Grid>
                    }

                    <Grid item xs={12} lg={4}>
                        <Card>
                            <CardContent>
                                <VistaIzquierda
                                    setData={setDataIzq}
                                    editable={editable}
                                    datos={datosEmpresa}
                                    handleUpdate={() => { handleUpdate('datos_generales') }}
                                    setImgs={(data) => { setImgs('datos_generales', data) }}
                                    imagenes={imagenesDatos}
                                />
                                <SolicitarEdicion empresa={datosEmpresa} setEditable={handleEditStatus} editable={editable} />
                            </CardContent>
                        </Card>
                    </Grid>


                    <Grid item xs={12} lg={8}>
                        <Card sx={{ display: { lg: 'block', xs: 'none' } }}>
                            <Tabs
                                value={tab}
                                onChange={handleTab}
                                variant='fullWidth'
                                scrollButtons="auto"
                            >
                                <Tab {...a11yProps(0)} label="Socios" />
                                <Tab {...a11yProps(1)} label="Antecedentes" />
                                <Tab {...a11yProps(2)} label="Objetivos" />
                                <Tab {...a11yProps(3)} label="Actividades Económicas" />
                                <Tab {...a11yProps(4)} label="Productos y Servicios" />
                                <Tab {...a11yProps(5)} label="Contacto comercial" />
                            </Tabs>
                            <CardContent>
                                {/* Socios */}
                                <TabPanel value={tab} index={0}>
                                    <SociosTab
                                        setImgs={(data) => { setImgs('socios', data) }}
                                        setData={setData}
                                        editable={editable}
                                        socios={socios}
                                        imagenes={imagenesDatos}
                                        handleUpdate={() => { handleUpdate('socios') }}
                                    />
                                </TabPanel>
                                {/* Antecedentes */}
                                <TabPanel value={tab} index={1}>
                                    <AntecedentesTab
                                        setImgs={(data) => { setImgs('antecedentes', data) }}
                                        setData={setData}
                                        editable={editable}
                                        antecedentes={antecedentes}
                                        imagenes={imagenesDatos}
                                        handleUpdate={() => { handleUpdate('antecedentes') }}
                                    />
                                </TabPanel>
                                {/* Objetivos */}
                                <TabPanel value={tab} index={2}>
                                    <ObjetivosTab
                                        setImgs={(data) => { setImgs('objetivos', data) }}
                                        setData={setData}
                                        editable={editable}
                                        datos={objetivos}
                                        imagenes={imagenesDatos}
                                        handleUpdate={() => { handleUpdate('objetivos') }}
                                    />
                                </TabPanel>
                                {/* Actividades Economicas */}
                                <TabPanel value={tab} index={3}>
                                    {/* Guardar en otro componente */}
                                    <ActividadesTab
                                        setImgs={(data) => { setImgs('actividades_economicas', data) }}
                                        setData={setData}
                                        editable={editable}
                                        imagenes={imagenesDatos}
                                        actividades={actividades}
                                        handleUpdate={() => { handleUpdate('actividades_economicas') }}
                                    />
                                </TabPanel>
                                <TabPanel value={tab} index={4}>
                                    <ProductosTab
                                        setImgs={(data) => { setImgs('productos_servicios', data) }}
                                        setData={setData}
                                        editable={editable}
                                        productos={productosServicios}
                                        imagenes={imagenesDatos}
                                        handleUpdate={() => { handleUpdate('productos_servicios') }}
                                    />
                                </TabPanel>
                                <TabPanel value={tab} index={5}>
                                    <ContactoTab
                                        setImgs={(data) => { setImgs('contacto_comercial', data) }}
                                        setData={setData}
                                        editable={editable}
                                        contacto={contactoComercial}
                                        imagenes={imagenesDatos}
                                        handleUpdate={() => { handleUpdate('contacto_comercial') }}
                                    />
                                </TabPanel>
                            </CardContent>
                        </Card>

                        <Card sx={{ display: { lg: 'none', xs: 'block' } }}>
                            <Tabs
                                value={tab}
                                onChange={handleTab}
                                variant='scrollable'
                                scrollButtons="auto"
                            >
                                <Tab {...a11yProps(0)} label="Socios" />
                                <Tab {...a11yProps(1)} label="Antecedentes" />
                                <Tab {...a11yProps(2)} label="Objetivos" />
                                <Tab {...a11yProps(3)} label="Actividades Económicas" />
                                <Tab {...a11yProps(4)} label="Productos y Servicios" />
                                <Tab {...a11yProps(5)} label="Contacto comercial" />
                            </Tabs>

                            {/* Socios */}
                            <TabPanel value={tab} index={0}>
                                <SociosTab socios={socios} imagenes={imagenes} editable={editable} setData={setData} />
                            </TabPanel>
                            {/* Antecedentes */}
                            <TabPanel value={tab} index={1}>
                                <AntecedentesTab antecedentes={antecedentes} imagenes={imagenes} editable={editable} setData={setData} />
                            </TabPanel>
                            {/* Objetivos */}
                            <TabPanel value={tab} index={2}>
                                <ObjetivosTab setImgs={(data) => { setImgs('objetivos', data) }} setData={setData} editable={editable} datos={objetivos} imagenes={imagenes} handleUpdate={() => { handleUpdate('objetivos') }} />
                            </TabPanel>
                            {/* Actividades Economicas */}
                            <TabPanel value={tab} index={3}>
                                {/* Guardar en otro componente */}
                                <ActividadesTab imagenes={imagenes} actividades={actividades} editable={editable} setData={setData} />
                            </TabPanel>
                            <TabPanel value={tab} index={4}>
                                <ProductosTab productos={productosServicios} imagenes={imagenes} editable={editable} setData={setData} />
                            </TabPanel>
                            <TabPanel value={tab} index={5}>
                                <ContactoTab contacto={contactoComercial} imagenes={imagenes} editable={editable} setData={setData} />
                            </TabPanel>
                        </Card>
                    </Grid>
                </Grid>

            </Box >
        )
    }

}

export default VistaEmpresa